<template>
  <div class="NewFriends">
    <van-nav-bar title="新朋友" left-arrow fixed @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="group">
      <van-cell-group v-for="(item, index) in newFriends" :key="index">
        <van-cell
          :title="item.u_nickname?item.u_nickname:item.u_login_id"
          :label="'邀请人：'+(item.u_inviter_id?item.u_inviter_id.u_nickname?item.u_inviter_id.u_nickname:item.u_inviter_id.u_login_id:'无')"
        >
          <van-image
            width="45px"
            height="45px"
            slot="icon"
            class="err-image-header"
            :src="attach_url+item.u_headportrait"
          />
          <van-button class="btn" @click="onSelectionGroup(item.u_id)">选择群</van-button>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
export default {
	name: "NewFriends",
	data() {
		return {
			newFriends: [],
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url: this.Conf.serverPre
		};
	},
	created() {
		this.getStateConfigs();
		this.loadData();
	},
	 methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		loadData() {
			var params = {
				u_id: this.u_id,
				token: this.token,
				num: Math.random()
			};
			var url = this.Conf.serverUrl + "Friends/getNewFriendsInfo";
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.newFriends = response.data.friends;
				var newfriends_ids = [];
				this.newFriends.forEach(element => {
					newfriends_ids.push(element.u_id);
				});
				var friendsinfo = {
					u_id: this.u_id,
					token: this.token,
					friendsinfo: newfriends_ids,
					num: Math.random()
				};
				var friendUrl = this.Conf.serverUrl + "Friends/upNewFriendsStatus";
				this.$axios
				.post(friendUrl, this.$qs.stringify(friendsinfo))
				.then(response => {})
				.catch(error => {});
			})
			.catch(error => {});
		},
		onClickLeft() {
			this.$router.push({
				name: "Friend",
				query: {
				}
			});
		},
		onSelectionGroup(id) {
			this.$router.push({
				name: "SelectionGroup",
				query: {
					u_id: id
				}
			});
		}
	}
};
</script>





// WEBPACK FOOTER //
// src/components/AddressList/NewFriends.vue